import { createStore, applyMiddleware, compose } from 'redux';
import reducer from './redux/index';
import rootEpic from './epics/index';
import isMobile from 'ismobilejs';
import middlewares from './epics/middlewares';

import {
  initialState as envInitialState,
  DEFAULT_MOBILE_SIZE,
  DEFAULT_DESKTOP_SIZE,
} from './redux/env';
import { initialState as modalsInitialState } from './redux/modals';
import { initialState as navInitialState } from './redux/nav';
import { initialState as dismissableBannerInitialState } from './redux/dismissableBanner';

import { createEpicMiddleware } from 'redux-observable';

export default function makeStore(initialState, { req }) {
  let stateToUse = initialState;

  // initialState starts as undefined, and then has default state values from the duck after
  // handing off to the client side.
  if (!initialState) {
    stateToUse = {
      env: envInitialState,
      modals: modalsInitialState,
      nav: navInitialState,
      dismissableBanner: dismissableBannerInitialState,
    };

    let uaIsMobile = true;
    let uaSize;
    if (req) {
      uaIsMobile = isMobile(req.header('user-agent')).any;
      uaSize = uaIsMobile ? DEFAULT_MOBILE_SIZE : DEFAULT_DESKTOP_SIZE;
    }

    const envProps = {
      isMobile: uaIsMobile,
      layoutSize: uaIsMobile ? 'mobile' : 'medium',
      windowWidth: uaSize.width,
    };

    stateToUse = { ...stateToUse, env: { ...stateToUse.env, ...envProps } };
  }

  const epicMiddleware = createEpicMiddleware(rootEpic);

  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  const reduxMiddleware = composeEnhancers(
    applyMiddleware(epicMiddleware, ...middlewares),
  );

  return createStore(reducer, stateToUse, reduxMiddleware);
}
